import './Tour.css';
import { useEffect, useState } from "react";
import MyLoader from "../../components/UI/MyLoader/MyLoader";

const Tour: React.FC = () => {
    const [isVisible, setVisible] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <>
            {isLoading && (
                <div className={`tour_container_loader ${isVisible && !isLoading ? 'visible' : ''}`}>
                    <span>
                        <MyLoader />
                    </span>
                </div>
            )}

            <div className={`tour_container ${!isLoading ? 'visible' : ''}`}>
                <div style={{
                    width: '100%',
                    height: '80vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2px solid #ffe5cc',
                    borderRadius: '10px',
                }}>
                    <iframe
                        style={{
                            borderRadius: '10px',
                            display: isLoading ? 'none' : 'block'
                        }}
                        src={`${process.env.REACT_APP_IMG_URL}/MeArtcom3D/index.htm`}
                        title="Virtual Tour"
                        name="VirtualTour"
                        width="100%"
                        height="100%"
                        onLoad={() => setLoading(false)}
                        allow="fullscreen; accelerometer; gyroscope; magnetometer; vr; xr; xr-spatial-tracking; autoplay; camera; microphone"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </>
    );
};

export default Tour;
